module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_10_B.48d5302b.mp3";